module.exports = __webpack_public_path__ + "img/a1.760854c6.png";